<template>
  <layout-component>
    <div class="banner banner-booking-success">
      <div class="container">
        <div class="row d-md-flex justify-content-md-center">
          <div class="col-md-8 col-lg-7 col-xl-6">
            <h1 class="left-bullet" v-html="$t('title-banner')"></h1>
            <p>{{ 'text-01'|t }}</p>

            <router-link class="btn" to="/dashboard" active-class="active"><span>{{ 'title-btn-big'|t }}</span></router-link>

            <div class="banner banner-booking-success-links-section first">
              <h3>{{ $t('title-next') }}</h3>

              <div class="cta-wrapper">
                <router-link class="btn-link mb-0" to="/book" active-class="active">{{ 'cta-room'|t }}</router-link>
                <router-link class="btn-link mb-0" to="/events" active-class="active">{{ 'cta-event'|t }}</router-link>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
	</layout-component>
</template>

<script>
    export default {
      mounted() {
        $('.title-anim-wrapper:in-viewport').addClass('in-viewport');
      }
    }
</script>

<i18n>
    {
      "en": {
        "title-banner": "<span class='title-anim-wrapper'><span class='title-anim'>Your booking</span></span> <span class='title-anim-wrapper'><span class='title-anim'>is confirmed</span></span>",
        "text-01": "Check your inbox for your confirmation email.",
        "title-btn-big": "Manage my bookings",
        "title-next": "What's next?",
        "cta-room": "Book a room",
        "cta-event": "Book an event"
      },
      "fr": {
        "title-banner": "<span class='title-anim-wrapper'><span class='title-anim'>Votre reservation</span></span> <span class='title-anim-wrapper'><span class='title-anim'>est confirmee</span></span>",
        "text-01": "Nous vous avons envoyé un email de confirmation.",
        "title-btn-big": "Gerer mes reservations",
        "title-next": "Que voulez-vous faire maintenant?",
        "cta-room": "Réserver une salle",
        "cta-event": "Réserver un événement"
      }
    }

</i18n>
